// 3rd party components goes here
import React, { useState, useEffect } from "react";
import { Col, Row, message } from "antd";
import { useSelector } from "react-redux";
import { ArrowProps } from "react-multi-carousel/lib/types";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import store, { RootState } from "../../../../store/index";
import styled from "styled-components";

// application components goes here
import MyAccountsArticles from "./myAccountsArticles";
import ArrowRight from "../../../../assets/img/icons/ArrowRight.svg";
import ArrowLeft from "../../../../assets/img/icons/ArrowLeft.svg";
import EmptyTabInfoTwo from "modules/Content/Shared/EmptyTabInfoTwo";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import FloatingPopover from "modules/Common/Components/FloatingPopover";
import ListPlaceholder from "../../WhatsHappeningNow/Components/ListPlaceholder";
import MyAccountsPlaceholder from "../Components/MyAccountsPlaceHolder";
import MyAccountsPlaceHolderTop from "./myAccountsPlaceHolderTop";
import {
  getMyAccounts,
  getAccountsNews,
  accountSearch,
  addAccount,
  unfollowAccount,
  resetAccountsNews,
  getAccountNewsFilters,
  resetMyAccounts,
  resetSelectedAccounts,
  resetSearchedAccounts,
} from "../actions";
import { IAccountItem, IAccountSearchItem, ISelectedAccounts } from "../../interfaces";
import { newsChunkArray, getPlanType } from "../../../../utils";
import { MY_ACCOUNTS, ACCOUNT_SEARCH, PREVIEW_ARTICLE, ACCOUNTS_NEWS } from "../../../../constants/actionTypes";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import SelectedBottom from "modules/Common/Components/SelectedBottom";
import { removeSelectedIds } from "modules/Content/DragnDrop/actions";
import { IFiltersItem, INewArticlesItem } from "../interface";
import AccountCompany from "./AccountCompany";
import { CONTENT_MY_ACCOUNTS } from "constants/messages";
import AccountCompanyAdd from "./AccountCompanyAdd";
import InfoPopover from "modules/Common/Components/InfoPopover";
import Tags from "../../../Common/Tags/Tags";
import ToolTip from "../../../Common/Tooltip/Tooltip";
import CloseFilledIcon from "assets/svgs/CloseFilledIcon";
import VerticalDivider from "assets/svgs/VerticalDivider";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 2200 },
    items: 8.4,
  },
  midLargeDesktop: {
    breakpoint: { max: 2200, min: 1750 },
    items: 6.3,
  },
  largeDesktop: {
    breakpoint: { max: 1750, min: 1460 },
    items: 5.3,
  },
  desktop: {
    breakpoint: { max: 1460, min: 1320 },
    items: 4.7,
  },
  miniDesktop: {
    breakpoint: { max: 1320, min: 1024 },
    items: 3.8,
  },
  tablet: {
    breakpoint: { max: 1023, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

interface CustomLeftArrowProps extends ArrowProps {
  myOwnStuff?: string;
}
const CustomLeftArrow = ({ onClick }: CustomLeftArrowProps) => {
  return (
    <button className="leftArrow" onClick={onClick}>
      <img src={ArrowLeft} alt="" />
    </button>
  );
};

const CustomRightArrow = ({ onClick }: CustomLeftArrowProps) => {
  return (
    <button className="rightArrow" onClick={onClick}>
      <img src={ArrowRight} alt="" />
    </button>
  );
};

type MyAccountsContainerProps = {
  isListView: boolean;
  allSearchTerms: string[];
  searchedAccounts: IAccountSearchItem[];
  searchMode: boolean;
  setSearchMode: any;
  setSearchTerms?: any;
  onFirstSearch?: any;
  searchedAccountsCount?: number
};

const MyAccountsContainer: React.FC<MyAccountsContainerProps> = (props: MyAccountsContainerProps) => {
  const { isListView, allSearchTerms, searchedAccounts, searchMode, setSearchMode, setSearchTerms, searchedAccountsCount } = props;
  const [filteredAccounts, setFilteredAccounts] = useState(Array<IAccountItem>());
  const [filterMode, setFilterMode] = useState(false);
  const [firstSearchKeyword, setFirstSearchKeyword] = useState("");
  const [getNewsAgain, setGetNewsAgain] = useState(false);
  const [reloadAccountsMode, setReloadAccountsMode] = useState(false);
  // use to handle the error if user cannot add new company to show the popup.
  const [isAddCompanyError, setIsAddCompanyError] = useState(false);

  const myAccounts: IAccountItem[] = useSelector((state: RootState) => state.myAccounts.data);
  const myAccountsLoading: boolean = useSelector((state: RootState) => state.myAccounts.loading);
  const selectedAccounts: ISelectedAccounts[] = useSelector((state: RootState) => state.myAccounts.selectedAccounts);
  const selectAll: boolean = useSelector((state: RootState) => state.myAccounts.selectAll);
  const selectedFilters: number[] = useSelector((state: RootState) => state.myAccounts.selectedFilters);
  const searchAccountLoading: boolean = useSelector((state: RootState) => state.accountSearch.loading);
  const newsArticles: INewArticlesItem[] = useSelector((state: RootState) => state.accountsNews.articles);
  const filters: IFiltersItem[] = useSelector((state: RootState) => state.accountsNews.filters);
  const accountsNewsLoading: boolean = useSelector((state: RootState) => state.accountsNews.loading);
  const accountsNewsPage: number = useSelector((state: RootState) => state.accountsNews.page);
  const onboard: boolean = useSelector((state: RootState) => state.myAccounts.onboard);
  const selectedIds = useSelector((state: RootState) => state.dragDrop.selectedIds);
  const myAccountIds = myAccounts.map((account) => account.accountId);

  const copyFiltersIntoPreviousState = () => {
    store.dispatch({
      type: MY_ACCOUNTS.UPDATE_PREVIOUS_FILTERS_STATE,
    });
  };
  useEffect(() => {
    if (filters.length <= 0) {
      getAccountNewsFilters(copyFiltersIntoPreviousState);
    }
    // check if added accounts length is not equal to initial loaded accounts length
    if (searchedAccounts.length === 0 && !onboard) {
      if (myAccounts.length === 0 && !myAccountsLoading) {
        getMyAccounts();
      }
    }

    if (newsArticles.length === 0 && !myAccountsLoading) {
      getAccountsNews(0, [], selectedFilters, selectAll);
    }

    store.dispatch({
      type: PREVIEW_ARTICLE.RESET_SEARCH_TERMS,
    });
    return () => {
      resetMyAccounts();
      resetSearchedAccounts()
      resetSelectedAccounts();
      resetAccountsNews();
    };
  }, []);

  useEffect(() => {
    if (getNewsAgain) {
      getAccountsNews(0, [], selectedFilters, selectAll);
      setGetNewsAgain(false);
    }
  }, [getNewsAgain]);

  const handleAccountSelection = (account: IAccountItem, accountState: string) => {
    if (!myAccountIds.includes(account.accountId)) return;
    if (searchMode) {
      if (account.state === "") {
        store.dispatch({
          type: ACCOUNT_SEARCH.UPDATE_SELECTED_STATE,
          companyId: account.accountId,
          updatedState: "selected",
        });
      } else if (account.state === "selected") {
        store.dispatch({
          type: ACCOUNT_SEARCH.UPDATE_SELECTED_STATE,
          companyId: account.accountId,
          updatedState: "",
        });
      }
    }
    if (newsArticles.length > 0) resetAccountsNews();
    if (accountState === "selected") {
      selectedAccounts.push({ accountName: account.accountName, accountId: account.accountId });
    } else {
      const removeIndex = selectedAccounts.findIndex((acc) => acc.accountId === account.accountId);
      selectedAccounts.splice(removeIndex, 1);
    }
    if (!searchMode) {
      for (const item of myAccounts) {
        if (item.accountId == account.accountId) {
          if (selectedAccounts.length > 0) {
            item.state = accountState;
          } else {
            item.state = "";
          }
        } else if (item.state !== "selected") {
          if (selectedAccounts.length > 0) {
            item.state = "disabled-company";
          } else {
            item.state = "";
          }
        }
      }
    }
    store.dispatch({
      type: MY_ACCOUNTS.UPDATE_STATE,
      payload: myAccounts,
      selectedAccounts: selectedAccounts,
    });
    store.dispatch({
      type: ACCOUNTS_NEWS.PAGE_RESET,
    });
    if (selectedAccounts.length > 0) {
      getAccountsNews(0, selectedAccounts.map((acc) => acc.accountId), selectedFilters, selectAll, true);
    } else {
      if (!searchMode) {
        getAccountsNews(0, [], selectedFilters, selectAll, true);
      }
    }
  };

  const handleUnfollow = (account: IAccountSearchItem, searchMode: boolean, setButtonLoading: (val: boolean) => void) => {
    unfollowAccount(account, searchMode, setButtonLoading).then(() => {
      const tempSelectedAccounts = [...selectedAccounts]
      const removeIndex = selectedAccounts.findIndex((acc) => acc.accountId === account.companyid);
      tempSelectedAccounts.splice(removeIndex, 1);
      store.dispatch({
        type: ACCOUNTS_NEWS.PAGE_RESET,
      });
      if (tempSelectedAccounts.length > 0) {
        getAccountsNews(0, tempSelectedAccounts.map((acc) => acc.accountId), selectedFilters, selectAll, true);
      } else {
        if (!searchMode) {
          getAccountsNews(0, [], selectedFilters, selectAll, true);
        }
      }
    })
  }

  function handleAccountFilter(keyword: string, cancel = false) {
    if (cancel) {
      setFilterMode(false);
    } else {
      setFilteredAccounts(
        myAccounts.filter((item) => item.accountName.toLowerCase().indexOf(keyword.toLowerCase()) >= 0)
      );
      setFilterMode(true);
    }
  }

  function handleAddAccount(account: IAccountSearchItem, setLoading: (val: boolean) => void) {
    if (myAccounts.length === 0 && !reloadAccountsMode) {
      setReloadAccountsMode(true);
    }
    setLoading(true)
    const result = addAccount(
      account.companyid,
      account.name,
      account.symbol,
      account.logo,
      account.accountPersonality,
      account.accountPulse
    );
    result
      .then((res: any) => {
        if (res === true) {
          setLoading(false)
          message.success(account.name + " has been added to your accounts")
          const updatedAccounts = updateSearchAccounts(account.companyid, "True");
          if (firstSearchKeyword.length > 0) {
            setSearchTerms([firstSearchKeyword]);
            setFirstSearchKeyword("");
          }
          setReloadAccountsMode(true);
          // resetting news data to refetch
          // resetAccountsNews();
          store.dispatch({
            type: ACCOUNT_SEARCH.UPDATE_STATE,
            payload: updatedAccounts,
          });

          // setGetNewsAgain(true);

          //* updating the accounts list
        } else {
          setIsAddCompanyError(true);
          const updatedAccounts = updateSearchAccounts(account.companyid, "False");
          store.dispatch({
            type: ACCOUNT_SEARCH.UPDATE_STATE,
            payload: updatedAccounts,
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  function updateSearchAccounts(companyId: number, flag: string): Array<IAccountSearchItem> {
    return searchedAccounts.map((searchAccount) => {
      if (searchAccount.companyid === companyId) {
        searchAccount.flag = flag;
        searchAccount.loading = false;
      }
      return searchAccount;
    });
  }

  function changeAddCompanyError() {
    setIsAddCompanyError(false);
  }

  function handleOnboardSearch(keyword: string) {
    setSearchMode(true);
    accountSearch(keyword);
    setFirstSearchKeyword(keyword);
  }

  function handleOnboardResetSearch() {
    setSearchMode(false);
    setFirstSearchKeyword("");
  }
  function loadMore() {
    if (myAccountIds.length > 0 && !accountsNewsLoading) {
      getAccountsNews(
        accountsNewsPage,
        selectedAccounts.length > 0 ? selectedAccounts.map((acc) => acc.accountId) : [],
        selectedFilters,
        selectAll
      );
    }
  }

  useEffect(() => {
    if (allSearchTerms.length > 0 && !reloadAccountsMode) {
      setReloadAccountsMode(true);
    }
    if (allSearchTerms.length === 0 && reloadAccountsMode) {
      if (!selectedAccounts.length) {
        resetAccountsNews();
        getAccountsNews(0, [], selectedFilters, selectAll);
      }
      setReloadAccountsMode(false);
      resetMyAccounts();
      getMyAccounts();
    } else if (allSearchTerms.length === 0 && newsArticles.length === 0 && myAccounts.length > 0) {
      if (!selectedAccounts.length) { getAccountsNews(0, [], selectedFilters, selectAll); }
    }
  }, [allSearchTerms, searchMode]);

  const handleClearClick = () => {
    store.dispatch({ type: ACCOUNT_SEARCH.RESET_SELECTION })
    resetSelectedAccounts()
    if (!searchMode) {
      resetAccountsNews();
      getAccountsNews(0, [], selectedFilters, selectAll);
    }
  }

  const accountHeading = () => {
    if (searchMode) {
      return `Matching Accounts (${searchedAccountsCount})`
    } else {
      return `My Accounts (${myAccounts.length})`
    }
  }

  const onTagCrossClick = (accountId: number) => {
    if (searchMode) {
      const tempAcc = searchedAccounts.find((acc) => acc.companyid === accountId)
      if (tempAcc) {
        handleAccountSelection({
          accountId: tempAcc.companyid,
          accountLogo: tempAcc.logo,
          accountName: tempAcc.name,
          state: tempAcc.state,
          flag: tempAcc.flag,
          accountPulse: [],
          accountPersonality: [],
          accountShare: '',
          accountSubscribers: '',
          accountTicker: ''

        }, 'disabled-company')
      } else {
        handleAccountSelection(myAccounts.find((acc) => acc.accountId === accountId)!, 'disabled-company')
      }
    } else {
      handleAccountSelection(myAccounts.find((acc) => acc.accountId === accountId)!, 'disabled-company')
    }
  }

  return (
    <>
      <MyAccountsStyle>
        <InfiniteLoader
          dataLength={newsArticles.length}
          next={loadMore}
          hasMore={!onboard}
          loader={
            isListView ? (
              <ListPlaceholder loading={accountsNewsLoading} />
            ) : (
              <MyAccountsPlaceholder loading={accountsNewsLoading} />
            )
          }
        >
          <div className="margin-top-sm pt-1">
            {/* first row */}
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
              <Col className="gutter-row mb-3 pb-1" span={24}>
                <div className="accounts-title">
                  <p>{accountHeading()}</p>
                  {selectedAccounts.length ?
                    <>
                      <span><ToolTip placement="bottomLeft" reactChild={
                        selectedAccounts.map((acc) =>
                        (<Tags
                          icon={<CloseFilledIcon onClick={() => onTagCrossClick(acc.accountId)} />}
                          key={acc.accountId}
                          bgColor='#E7EDFF'
                          tagTitle={acc.accountName}
                          textColor={"#001760"}
                          showIcon={true} />)
                        )
                      } tooltipText={'Selected ' + `(${selectedAccounts.length})`} /></span>
                      <span className="vertical-divider"><VerticalDivider /></span><span onClick={handleClearClick}> Clear all</span>
                    </>
                    :
                    null
                  }
                </div>
              </Col>

              {onboard ? (
                <Col className="gutter-row mb-3 pb-1" span={24}>
                  <EmptyTabInfoTwo
                    description="After you've created or imported a few contacts, companies or accounts, we'll bring in new content of interest to them right here - automatically. Like magic."
                    placeholder="Search for accounts..."
                    btnText="Search for accounts"
                    handleOnboardSearch={handleOnboardSearch}
                    handleResetInput={handleOnboardResetSearch}
                  />
                </Col>
              ) : null}

              <Col className="gutter-row mb-2 pb-1" span={24}>
                {searchMode ? (
                  <div>
                    {searchedAccounts ? (
                      searchAccountLoading ? (
                        <MyAccountsPlaceHolderTop loading={true} />
                      ) : (
                        <div className="search-company">
                          <Carousel
                            swipeable={true}
                            draggable={true}
                            responsive={responsive}
                            containerClass="carousel-container"
                            keyBoardControl={true}
                            customLeftArrow={<CustomLeftArrow />}
                            customRightArrow={<CustomRightArrow />}
                          >
                            {searchedAccounts.map((account, index) => (
                              <AccountCompanyAdd
                                unfollowAccount={handleUnfollow}
                                state={account.state}
                                account={account}
                                index={index}
                                key={index}
                                handleAddAccount={handleAddAccount}
                                handleAccountSelection={handleAccountSelection}
                                checked={false}
                                searchMode={searchMode}
                              />
                            ))}
                          </Carousel>
                        </div>
                      )
                    ) : null}
                    {searchedAccounts.length === 0 && !searchAccountLoading ? (
                      <p className="text-center">No account(s) found against your search.</p>
                    ) : null}
                  </div>
                ) : null}

                {filterMode && !onboard ? (
                  filteredAccounts.length > 0 ? (
                    <Carousel
                      swipeable={true}
                      draggable={true}
                      responsive={responsive}
                      containerClass="carousel-container"
                      keyBoardControl={true}
                      customLeftArrow={<CustomLeftArrow />}
                      customRightArrow={<CustomRightArrow />}
                    >
                      {filteredAccounts.map((account: IAccountItem) => (
                        <AccountCompany
                          key={account.accountId}
                          account={account}
                          handleAccountSelection={handleAccountSelection}
                          checked={selectedAccounts.length === 0 ? true : false}
                          hideSelected={!myAccountIds.includes(account.accountId)}
                        />
                      ))}
                    </Carousel>
                  ) : (
                    "No account(s) found against your search."
                  )
                ) : null}

                {!searchMode && !filterMode && !onboard ? (
                  myAccounts ? (
                    myAccountsLoading ? (
                      <MyAccountsPlaceHolderTop loading={true} />
                    ) : (
                      <Carousel
                        swipeable={true}
                        draggable={true}
                        responsive={responsive}
                        containerClass="carousel-container"
                        keyBoardControl={true}
                        customLeftArrow={<CustomLeftArrow />}
                        customRightArrow={<CustomRightArrow />}
                      >
                        {myAccounts.map((account, index) => (
                          <AccountCompanyAdd
                            state={account.state}
                            account={{
                              companyid: account.accountId,
                              logo: account.accountLogo,
                              accountPulse: account.accountPulse,
                              accountPersonality: account.accountPersonality,
                              accountSubscribers: account.accountSubscribers,
                              accountShare: account.accountShare,
                              accountTicker: account.accountTicker,
                              name: account.accountName,
                              flag: account.flag
                            }}
                            unfollowAccount={handleUnfollow}
                            index={index}
                            key={index}
                            handleAddAccount={handleAddAccount}
                            handleAccountSelection={handleAccountSelection}
                            checked={false}
                            searchMode={searchMode}
                          />
                        ))}
                      </Carousel>
                    )
                  ) : (
                    "No accounts"
                  )
                ) : null}
              </Col>

              {(!searchMode || selectedAccounts.length > 0) &&
                (!onboard ? (
                  <Col className="gutter-row mt-4 mb-1" span={24}>
                    <div className="accounts-title"><p>Tailored Content</p> <InfoPopover popoverClass="tailored-content-popup" className="info-popover-class" placement="bottomRight" infoText={'The articles displayed are related to the accounts you have selected above. You can select multiple accounts to tailor the content to your preferences.'} width={400} /></div>
                  </Col>
                ) : null)}
            </Row>

            {
              <>
                {selectedAccounts.length > 0 &&
                  newsArticles?.length === 0 &&
                  accountsNewsLoading === false &&
                  myAccountsLoading === false && (
                    <EmptyTabInfo description="No recommended articles found against your account selection" />
                  )}
                {(!searchMode || (searchMode && selectedAccounts.length > 0)) && (
                  <>
                    {newsChunkArray(newsArticles, 21).map((subArtilces, index) => (
                      <MyAccountsArticles articles={subArtilces} key={index} isListView={isListView} />
                    ))}
                  </>
                )}
              </>
            }
          </div>
        </InfiniteLoader>
        <SelectedBottom
          hideAction={true}
          selectedCount={selectedIds?.length}
          selectedMessage={` ${selectedIds.length === 1 ? "article" : "articles"} selected`}
          onClearSelection={removeSelectedIds}
        />
        {getPlanType().toUpperCase() !== "ENTERPRISE" && searchMode && (
          <FloatingPopover
            contentType="account"
            onVisibleChange={() => {
              // * Add a logic when a user click away from the upgrade popup
              changeAddCompanyError();
            }}
            isPopoverVisible={isAddCompanyError}
          />
        )}
      </MyAccountsStyle>
    </>
  );
};

export default MyAccountsContainer;

const MyAccountsStyle = styled.div`
  display: inline-block;
  .accounts-title {
    display: flex;
    align-items: center;
    position: relative;
    // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    //   font-size: 13px;
    //   margin: 0;
    // }
    p {
      color: #67696a;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 0;
      font-family: "Roboto";
      margin-right: 12px;
      @media (max-width: 1439px) {
        font-size: 13px;
        margin-right: 4px;
      }
    }
    .selected {
      color: #1EC252;
    }
    .separator {
      padding: 0;
    }
    span {
      font-family: Roboto;
      padding: 0 12px;
      font-size: 16px;
      font-weight: 500;
      line-height: 18.71px;
      color: #7E7E7E;
      cursor: pointer;
      // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      //   font-size: 13px;
      // }
      @media all and (max-width: 1439px) {
        font-size: 13px;
      }
    }
    .vertical-divider {
      padding: 0
    }
  }
  .info-popover-class {
    height: 17px;
    @media all and (max-width: 1439px), (max-height: 729px) {
      height: 15px
    }
  }
  .search-company {
    .react-multi-carousel-list.carousel-container {
      // &:before {
      //   height: 225px;
      // }
      .leftArrow,
      .rightArrow {
        top: 25%;
      }
    }
  }
  .react-multi-carousel-list.carousel-container {
    margin-right: -90px;
    padding-right: 90px;
    // padding-left: 90px;
    // margin-left: -90px;
    box-sizing: content-box;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-right: -65px;
      padding-right: 65px;
    }
    ul {
      margin-left: -7px;
      li {
        max-width: 283px;
        > div {
          width: 100%;
          > div {
            width: calc(100% - 14px);
          }
        }
      }
    }
    // &:before {
    //   content: "";
    //   left: 0;
    //   top: 0;
    //   width: 90px;
    //   height: 190px;
    //   background: #f2f2f2;
    //   z-index: 1;
    //   position: absolute;
    // }
    .leftArrow {
      position: absolute;
      outline: 0;
      transition: all 0.5s;
      border-radius: 35px;
      z-index: 1;
      border: 0;
      background: #fff;
      min-width: 43px;
      min-height: 43px;
      opacity: 1;
      cursor: pointer;
      box-shadow: 0 0 14px 5px rgb(0 0 0 / 10%);
      top: 30%;
      left: 20px;
      img {
        margin-left: -3px;
      }
    }
    .rightArrow {
      position: absolute;
      outline: 0;
      right: 20px;
      transition: all 0.5s;
      border-radius: 35px;
      z-index: 1;
      border: 0;
      background: #fff;
      min-width: 43px;
      min-height: 43px;
      opacity: 1;
      cursor: pointer;
      box-shadow: 0 0 14px 5px rgb(0 0 0 / 10%);
      top: 30%;
      img {
        margin-right: -3px;
      }
    }
  }
  .account-row {
    display: block;
    float: left;
    min-width: 100%;
    height: 200px;
    position: relative;
    > div {
      width: calc(100% + 90px);
      float: left;
      position: absolute;
      z-index: 0;
      overflow-x: scroll;
      overflow-y: hidden;
      scrollbar-width: thin;
      scrollbar-color: #001760 transparent;
      // -ms-overflow-style: none; /* IE and Edge */
      // scrollbar-width: none; /* Firefox */
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      ::-webkit-scrollbar {
        width: 40px;
        height: 5px;
        border-radius: 2px;
      }
      /* Track */
      ::-webkit-scrollbar-track {
        background: transparent;
        margin-top: 10px;
        margin-bottom: 15px;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #001760;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
`;
